<script setup lang="ts">
  import type { IBreadcrumb } from '@/components/breadcrumbs/types'

  const props = withDefaults(
    defineProps<{
      breadcrumbs: IBreadcrumb[]
      hasHero?: boolean
    }>(),
    {
      hasHero: false
    }
  )

  const runtimeConfig = useRuntimeConfig()

  type TListItem = {
    '@type': string
    position: number
    name: string
    item: string | null
  }

  const jsonLD = computed(() => {
    const itemListElement: TListItem[] = props.breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: runtimeConfig.public.siteUrl + item.href
    }))

    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement,
      itemListOrder: 'Ascending',
      numberOfItems: props.breadcrumbs.length
    }
  })

  useHead({
    script: [
      {
        id: 'breadcrumbs-json-ld',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(jsonLD.value)
      }
    ]
  })
</script>

<template>
  <nav
    class="container"
    :class="{ 'mt-10': !hasHero }"
  >
    <ul class="flex gap-4 p-0">
      <li
        v-for="(link, index) in breadcrumbs"
        :key="link.name"
        class="flex items-center gap-4 md:mb-0"
      >
        <template v-if="index + 1 !== breadcrumbs.length && link.href">
          <NuxtLink
            :to="link.href"
            class="text-secondary no-underline"
            external
          >
            {{ link.name }}
          </NuxtLink>
          <span class="text-secondary"> / </span>
        </template>
        <span
          v-else
          class="text-secondary"
        >
          {{ link.name }}
        </span>
      </li>
    </ul>
  </nav>
</template>
